import * as React from 'react';
import { isArray } from 'easit--utils';

interface ITicketAndCouponMessageProps {
    headerText?: string;
    messages?: IMessageItem | IMessageItem[];
}

interface IMessageItem {
    text: string;
    withIcon?: boolean;
}

/**
 *
 * For desktop only (replaced by <InfoBox type='error')
 */
export const TicketAndCouponMessage: React.FC<ITicketAndCouponMessageProps> = (props: ITicketAndCouponMessageProps) => {
    const { headerText, messages = [] } = { ...props }
    const items = isArray(messages) ? messages : [messages];
    return (
        <div className="ticket-messages">
            {
                headerText &&
                <React.Fragment>
                    <span className="ticket-message-header">
                        {headerText}
                    </span> <br />
                </React.Fragment>
            }
            {
                items.map((message, key) =>
                    <div className="ticket-message" key={key}>
                        {
                            message.withIcon &&
                            <span className="error-icon fas fa-exclamation flex-shrink-0"></span>
                        }
                        {message.text}
                    </div>
                )
            }
        </div>
    )
}